import React from 'react';
import { Theme, Typography } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';

interface Props {
  children: React.ReactNode;
}

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  root: {
    color: colorPalette.marine.main,
    margin: `${spacing(0, 0, 4)} !important`,
    textAlign: 'center',
    '&:after': {
      backgroundColor: colorPalette.primary.main,
      content: "''",
      display: 'block',
      height: 3,
      margin: spacing(1.5, 'auto', 0),
      width: 40,
    },
  },
}));

export function PageTitle({ children }: Props): React.ReactElement {
  const classes = useStyles();
  return (
    <Typography variant="h1" className={classes.root}>
      {children}
    </Typography>
  );
}
